import * as React from 'react';
import { memo } from 'react';

var _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 16v128c-35.299 0-64-28.701-64-64s28.591-64 64-64Z",
    fill: "#E6F0F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.273 99.818v-24c0-15.927-10.08-29.476-24.175-34.734C92.138 34.8 86.728 30 80.182 30s-11.957 4.822-12.938 11.084C53.149 46.342 43.09 59.89 43.09 75.818v24c0 7.222-5.87 13.091-13.091 13.091h100.364c-7.244 0-13.091-5.869-13.091-13.09ZM93.273 112.909c0 7.222-5.87 13.091-13.091 13.091-7.244 0-13.091-5.869-13.091-13.091",
    stroke: "#0C1733",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 36,
    r: 6,
    fill: "#DF3B26"
  })));
};

var Memo = /*#__PURE__*/memo(SvgNotifications);

export { Memo as default };
//# sourceMappingURL=notifications.svg.js.map
